<template>
    <div id="vue-app">
        <router-view/>
    </div>
</template>

<script setup>
    import {onMounted, onUnmounted} from "vue";

    const setViewportHeight = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    onMounted(() => {
        setViewportHeight();
        window.addEventListener("resize", setViewportHeight);
    });

    onUnmounted(() => {
        window.removeEventListener("resize", setViewportHeight);
    });

    function updateAriaLabels(root = document) {
        root.querySelectorAll("[aria-label='close']").forEach((el) => {
            el.setAttribute("aria-label", "zamknij");
        });
    }

    updateAriaLabels();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    updateAriaLabels(node);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
</script>

<style lang="less">
    @import "assets/theme/global-styles";

    html, body, #app, #vue-app {
        height: calc(var(--vh, 1vh) * 100);
        margin: 0;
        padding: 0;
    }

    #vue-app {
        display: flex;
        flex-direction: column;
    }

    router-view {
        flex: 1;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }
</style>
